// 請求転換の再予約で表示するキャンセル料テキストを選ぶ。
// cancy は請求転換のとき「前回予約が 0 円か (origin_price == 0)」でメニューあり用 / メニューなし用の
// どちらか片方だけにテキストを入れて返す (CompanySmsSendingRuleV2WithCancelTypeSettings.get_cancel_policy_str_for_canceled_reservation)。
// メニューの有無で選ぶと「メニューはあるが 0 円」の予約で空のリストを選んでしまうため、値が入っている方を使う
export const pickClaimingConversionCancelConditionTexts = (
	textsForMenu: string[] | null | undefined,
	textsForNoMenu: string[] | null | undefined
): string[] => {
	if (textsForMenu && textsForMenu.length > 0) {
		return textsForMenu
	}
	return textsForNoMenu ?? []
}
